import { http } from "@/util/http";
import { handleRequest } from "..";
import { CaptchaResponse } from "@/types/validator";

export const getCaptchaApi = async (): Promise<CaptchaResponse | null> => {
  return handleRequest<CaptchaResponse>(
    http.get("/captcha/fetchCaptcha"),
    (response) => response.data
  );
};
